var HtmlComponent_default = {
  "htmlComponent": "Q6sli",
  "htmlComponent_placeholder": "LKMSD"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
